
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ixgeqoybdddgrmzooniz.supabase.co';
const supabaseKey = 'sb_publishable_--l2WXZdwESC5iia1VvXhg_cbyIcZZ3';

export const supabase = createClient(supabaseUrl, supabaseKey);
